export default "__VITE_ASSET__Cd_FB3Zc__"